import * as svg from "../../../assets/external.svg";

import {iconBuilder} from "./iconBuilder";

const ExternalIcon = iconBuilder(svg, "ExternalIcon", "0 0 16 16");

export default ExternalIcon;
